export const liveProjectsData = [
  {
    _id: "6",
    title: "Takly",
    description:
      "A real-time chat platform for personal and group communication, supporting multimedia messaging, voice and video messages, online/offline status, notifications, and real-time connection management.",
    longDesc:
      "Takly is a real-time chat platform focused on fast and interactive communication between users. I was responsible for developing the frontend of the platform with React, including personal and group conversations, group management, user profiles, multimedia messaging, voice and video messages, real-time message updates, online/offline status, notifications, connection and reconnection handling, and responsive chat interfaces.",
    tech: ["React.js", "Redux", "RTK", "Material UI", "WebSocket"],
    image: "/media/LiveProjects/takly1.webp",
    images: [
      "/media/LiveProjects/takly1.webp",
      "/media/LiveProjects/takly2.webp",
    ],
    video:
      "[https://assets.mixkit.co/videos/preview/mixkit-programming-interface-with-a-desktop-41568-large.mp4](https://assets.mixkit.co/videos/preview/mixkit-programming-interface-with-a-desktop-41568-large.mp4)",
    liveUrl: "https://chat.takly.ir",
    color: "rgba(0, 94, 255, 1)",
    stats: {},
    doneTime: "",
    keyFeatures: [
      "Real-time personal and group messaging",
      "Group creation and member management",
      "Text and multimedia messaging",
      "Voice message recording and sending",
      "Video message recording and sending",
      "Real-time online/offline user status",
      "Message notifications and real-time conversation updates",
      "Connection and reconnection management",
      "Responsive chat interface",
      "Performance optimization for conversations with large numbers of messages",
    ],
    tools: ["react", "redux", "rtk", "mui", "websocket"],
    myPositionInProject: "create",
    myRole: "frontend",
    teamSize: 1,
    collaborationType: "alone",
    contributionType: "full",
    teamMembers: [],
  },
  {
    _id: "9",
    title: "Vira Arvand Aria",
    description:
      "The official responsive website of Vira Arvand Aria, presenting the company's services, projects, capabilities, and activities.",
    longDesc:
      "A corporate website developed with React for presenting Vira Arvand Aria, its services, projects, capabilities, and activities. I developed reusable components, responsive pages, project and service sections, animations and interactions, dynamic API-based content, forms, SEO-friendly structures, performance improvements, and ongoing frontend maintenance.",
    tech: ["React.js", "Redux Toolkit", "RTK Query", "Material UI"],
    image: "/media/LiveProjects/vira3.webp",
    images: [
      "/media/LiveProjects/vira1.webp",
      "/media/LiveProjects/vira2.webp",
      "/media/LiveProjects/vira3.webp",
    ],
    video:
      "[https://assets.mixkit.co/videos/preview/mixkit-programming-interface-with-a-desktop-41568-large.mp4](https://assets.mixkit.co/videos/preview/mixkit-programming-interface-with-a-desktop-41568-large.mp4)",
    liveUrl: "https://vira-tec.ir",
    color: "rgba(4, 83, 0, 1)",
    stats: {},
    doneTime: "",
    keyFeatures: [
      "Company and service introduction pages",
      "Project portfolio section",
      "Reusable component architecture",
      "Responsive design",
      "Animations and UI interactions",
      "Dynamic API-based content",
      "Dynamic content management",
      "Interactive forms",
      "SEO optimization",
      "Performance optimization",
      "Continuous frontend development and maintenance",
      "Bug fixing and refactoring",
    ],
    tools: ["react", "redux", "rtk", "mui", "framer-motion", "gsap"],
    myPositionInProject: "create",
    myRole: "frontend",
    teamSize: 3,
    collaborationType: "withTeam",
    contributionType: "full",
    teamMembers: [],
  },
  {
    _id: "15",
    title: "AdinZone",
    description:
      "A platform for discovering sports clubs and coaches, including profiles, services, search, filtering, ratings, and user reviews.",
    longDesc:
      "AdinZone is a platform for introducing sports clubs and coaches and helping users discover and evaluate them. I developed the frontend with React, including club and coach profile pages, service information, rating and review systems, search and filtering, dynamic API-based data, reusable components, responsive interfaces, state management, validation, and loading, error, and empty states.",
    tech: ["React.js"],
    image: "/media/LiveProjects/adin1.webp",
    images: [
      "/media/LiveProjects/adin1.webp",
      "/media/LiveProjects/adin1.webp",
    ],
    liveUrl: "https://adinzone.ir",
    color: "#4c4d4eff",
    stats: {},
    doneTime: "",
    keyFeatures: [
      "Sports club profiles",
      "Sports coach profiles",
      "Club and coach service information",
      "User ratings and reviews",
      "Rating and review forms with validation",
      "Search and filtering",
      "Dynamic API-based data",
      "Reusable components",
      "Responsive design",
      "State management",
      "Loading, error, and empty states",
      "Performance and UX optimization",
      "Frontend maintenance and bug fixing",
    ],
    tools: ["react"],
    myPositionInProject: "create",
    myRole: "frontend",
    teamSize: 1,
    collaborationType: "withTeam",
    contributionType: "full",
    teamMembers: [],
  },
  {
    _id: "1",
    title: "Nimobile",
    description:
      "A responsive e-commerce platform for mobile phones, accessories, and smart gadgets, including product browsing, search, filtering, cart, wishlist, user accounts, and order tracking.",
    longDesc:
      "NiMobile is an online store focused on mobile phones, accessories, and smart gadgets. I was responsible for developing the frontend with React, including product and category pages, product search and filtering, shopping cart, wishlist, user authentication and account management, order tracking, location-based product filtering, responsive UI, API integration, form validation, and SEO improvements.",
    tech: ["React.js", "Redux Toolkit", "RTK Query", "Material UI", "Axios"],
    image: "/media/LiveProjects/nimobile1.webp",
    images: [
      "/media/LiveProjects/nimobile1.webp",
      "/media/LiveProjects/nimobile2.webp",
    ],
    liveUrl: "https://nimobile.store",
    githubUrl: "",
    color: "rgb(220, 184, 104)",
    stats: {},
    doneTime: "",
    keyFeatures: [
      "Product and category pages",
      "Product search and filtering",
      "Shopping cart and purchase flow",
      "Wishlist management",
      "User registration and login",
      "User account and order management",
      "Order tracking",
      "Location and city-based product filtering",
      "Responsive design for mobile, tablet, and desktop",
      "API integration and dynamic data management",
      "Form validation and error handling",
      "SEO optimization for product and category pages",
    ],
    tools: ["react", "redux", "rtk", "mui", "axios"],
    myPositionInProject: "create",
    myRole: "frontend",
    teamSize: 1,
    collaborationType: "withTeam",
    contributionType: "full",
    teamMembers: ["backend developer", "UI designer"],
  },

  {
    _id: "10",
    title: "E-commerce Dashboard",
    description:
      "A comprehensive management dashboard for e-commerce websites, covering products, categories, images, SEO content, sliders, banners, orders, forms, tables, permissions, and dynamic website content.",
    longDesc:
      "An administration dashboard developed with React for managing different parts of e-commerce websites through a centralized panel. The dashboard includes product and category management, product image management and metadata, rich text editing, SEO content management, sliders and banners, dynamic website content, complex forms, validation, management tables, API integration, state management, permissions, file uploads, and responsive administration interfaces.",
    tech: ["React.js", "Redux Toolkit", "RTK Query", "Material UI", "Recharts"],
    image: "/media/LiveProjects/panel1.webp",
    images: [
      "/media/LiveProjects/panel1.webp",
      "/media/LiveProjects/panel2.webp",
    ],
    video:
      "[https://assets.mixkit.co/videos/preview/mixkit-programming-interface-with-a-desktop-41568-large.mp4](https://assets.mixkit.co/videos/preview/mixkit-programming-interface-with-a-desktop-41568-large.mp4)",
    liveUrl: "https://hidden.ir",
    color: "rgb(43, 54, 68)",
    stats: {},
    doneTime: "",
    keyFeatures: [
      "Product and category management",
      "Product image and visual content management",
      "Image metadata management including Alt, Title, Caption, and Description",
      "Rich text editor for website content",
      "SEO content management",
      "Meta Title, Meta Description, Keywords, and Open Graph management",
      "Slider and banner management",
      "Dynamic website content management",
      "Complex dynamic forms with validation",
      "Management tables with sorting, filtering, search, and pagination",
      "API integration and state management",
      "Permission and access management",
      "File and image upload management",
      "Responsive dashboard",
      "Performance optimization for heavy administrative pages",
    ],
    tools: ["react", "redux", "rtk", "mui", "recharts"],
    myPositionInProject: "create",
    myRole: "frontend",
    teamSize: 1,
    collaborationType: "alone",
    contributionType: "full",
    teamMembers: [],
  },

  {
    _id: "5",
    title: "Conte",
    description:
      "A responsive e-commerce platform for stationery, with product browsing, search, filtering, shopping cart, authentication, API integration, and an administration panel.",
    longDesc:
      "Conte is an online stationery store where I was responsible for designing and developing the frontend from implementation to final delivery. The project included reusable component architecture, product and category pages, product search and filtering, shopping cart, forms and user interactions, API integration, Redux Toolkit and RTK Query, responsive design, authentication and access management, administration panel interfaces, performance optimization, accessibility, UX/UI, and SEO considerations.",
    tech: ["React.js", "Redux Toolkit", "RTK Query", "Material UI", "Axios"],
    image: "/media/LiveProjects/conte1.webp",
    images: [
      "/media/LiveProjects/conte1.webp",
      "/media/LiveProjects/conte2.webp",
    ],
    video:
      "[https://assets.mixkit.co/videos/preview/mixkit-programming-interface-with-a-desktop-41568-large.mp4](https://assets.mixkit.co/videos/preview/mixkit-programming-interface-with-a-desktop-41568-large.mp4)",
    liveUrl: "https://conte.ir",
    color: "rgb(254, 202, 48)",
    stats: {},
    doneTime: "",
    keyFeatures: [
      "Reusable component-based frontend architecture",
      "Product, category, and product detail pages",
      "Product search and filtering",
      "Shopping cart and purchase-related flows",
      "Forms and user interactions",
      "Backend API integration",
      "Redux Toolkit and RTK Query state and API management",
      "Responsive interface for mobile, tablet, and desktop",
      "Administration panel interfaces",
      "Authentication and user access management",
      "Performance optimization",
      "Accessibility and SEO considerations",
    ],
    tools: ["react", "redux", "rtk", "mui", "axios"],
    myPositionInProject: "create",
    myRole: "frontend",
    teamSize: 3,
    collaborationType: "withTeam",
    contributionType: "full",
    teamMembers: ["backend developer", "content manager"],
  },

  {
    _id: "3",
    title: "Kavosh Andishe Rastegar",
    description:
      "A responsive corporate website for Kavosh Andishe Rastegar, focused on presenting the company's services, activities, and professional information.",
    longDesc:
      "A corporate website developed with React for introducing Kavosh Andishe Rastegar, its services, areas of activity, and company information. My responsibilities included implementing the complete frontend, converting the visual design into a responsive interface, creating reusable components, implementing navigation with React Router, connecting dynamic sections to backend APIs, optimizing performance, improving UX/UI, and applying SEO principles.",
    tech: ["React.js", "React Router", "CSS Modules"],
    image: "/media/LiveProjects/kavosh1.webp",
    images: [
      "/media/LiveProjects/kavosh1.webp",
      "/media/LiveProjects/kavosh2.webp",
    ],
    video:
      "[https://assets.mixkit.co/videos/preview/mixkit-yoga-app-interface-47191-large.mp4](https://assets.mixkit.co/videos/preview/mixkit-yoga-app-interface-47191-large.mp4)",
    liveUrl: "https://kavoshandisheh.ir/",
    githubUrl: "",
    color: "#1a2944",
    stats: {},
    doneTime: "",
    keyFeatures: [
      "Responsive corporate interface",
      "Company introduction pages",
      "Services and areas of expertise",
      "Reusable components",
      "Responsive design for mobile, tablet, and desktop",
      "Dynamic API-based content",
      "Navigation with React Router",
      "Performance optimization",
      "SEO-friendly page structure",
      "UX/UI improvements",
      "Bug fixing and refactoring",
    ],
    tools: ["react", "react-router", "css"],
    myPositionInProject: "create",
    myRole: "frontend",
    teamSize: 2,
    collaborationType: "withTeam",
    contributionType: "full",
    teamMembers: ["backend developer", "graphic designer"],
  },

  {
    _id: "4",
    title: "Niknam Nuts",
    description:
      "A responsive e-commerce platform for Niknam Nuts, focused on selling nuts and dried fruits with product browsing, filtering, shopping cart, and order management.",
    longDesc:
      "An online store for Niknam Nuts where I developed the frontend using React. The project includes product, category, and product detail pages, product search and filtering, shopping cart and order flows, responsive design, reusable components, backend API integration, Redux Toolkit and RTK Query for state and API management, forms and validation, performance improvements, SEO, accessibility, and continuous feature development.",
    tech: ["React.js", "Redux Toolkit", "RTK Query", "Material UI", "Axios"],
    image: "/media/LiveProjects/niknam1.webp",
    images: [
      "/media/LiveProjects/niknam1.webp",
      "/media/LiveProjects/niknam2.webp",
    ],
    video:
      "[https://assets.mixkit.co/videos/preview/mixkit-programming-interface-with-a-desktop-41568-large.mp4](https://assets.mixkit.co/videos/preview/mixkit-programming-interface-with-a-desktop-41568-large.mp4)",
    liveUrl: "https://niknamnuts.ir",
    color: "rgb(223, 134, 38)",
    stats: {},
    doneTime: "",
    keyFeatures: [
      "Product and category pages",
      "Product search and filtering",
      "Shopping cart and order flow",
      "Responsive design",
      "Reusable component architecture",
      "Backend API integration",
      "Redux Toolkit and RTK Query",
      "Form validation and user interactions",
      "Performance optimization",
      "SEO and accessibility improvements",
      "Bug fixing and feature development",
    ],
    tools: ["react", "redux", "rtk", "mui", "axios"],
    myPositionInProject: "create",
    myRole: "frontend",
    teamSize: 2,
    collaborationType: "withTeam",
    contributionType: "full",
    teamMembers: ["backend developer", "sales consultant"],
  },

  {
    _id: "2",
    title: "Standards Sample Automation",
    description:
      "A web-based administrative automation system for registering, managing, referring, inspecting, and distributing standard samples between companies, inspectors, and laboratories.",
    longDesc:
      "A comprehensive administrative automation system designed to digitize the workflow of standard sample management. I developed the frontend with React, including company management, standard codes and domains, products and laboratories, standards and tests, inspection and laboratory requests, dynamic forms, workflow management, role-based interfaces, request status management, large-data management tables, filtering, search, pagination, validation, API integration, responsive interfaces, and performance optimization.",
    tech: ["React.js", "Redux", "Material UI"],
    image: "/media/LiveProjects/notAllowed.jpg",
    images: [
      "/media/LiveProjects/notAllowed.jpg",
      "/media/LiveProjects/notAllowed.jpg",
    ],
    video:
      "[https://assets.mixkit.co/videos/preview/mixkit-online-shopping-interface-43387-large.mp4](https://assets.mixkit.co/videos/preview/mixkit-online-shopping-interface-43387-large.mp4)",
    liveUrl: "",
    githubUrl: "",
    color: "rgb(25, 118, 210)",
    stats: {},
    doneTime: "",
    keyFeatures: [
      "Company registration and management",
      "Standard code and domain management",
      "Product and product type management",
      "Laboratory management",
      "Standard and test type management",
      "Inspection and laboratory request workflow",
      "Dynamic forms for different request types",
      "Request referral to inspectors and laboratories",
      "Role-based interfaces",
      "Request status management",
      "Management tables with search, filtering, and pagination",
      "Complex multi-step forms",
      "Validation and error handling",
      "API integration and state management",
      "Performance optimization for large datasets",
    ],
    tools: ["react", "redux", "mui"],
    myPositionInProject: "create",
    myRole: "frontend",
    teamSize: 3,
    collaborationType: "withTeam",
    contributionType: "full",
    teamMembers: ["backend developer", "UI/UX designer", "project manager"],
  },

  {
    _id: "99",
    title: "Major Niknam Nuts",
    description:
      "A responsive e-commerce platform for Major Niknam, focused on providing a simple and fast shopping experience for nuts and dried fruits.",
    longDesc:
      "Major Niknam is an online store for nuts and dried fruits. I developed the frontend using React, including the main store pages, product and category pages, product search and filtering, shopping cart, user account management, API integration, reusable components, responsive design, state management, forms and validation, performance optimization, bug fixing, and SEO improvements.",
    tech: ["React.js", "Redux Toolkit", "RTK Query", "Material UI"],
    image: "/media/LiveProjects/majorniknam1.webp",
    images: [
      "/media/LiveProjects/majorniknam1.webp",
      "/media/LiveProjects/majorniknam2.webp",
    ],
    video:
      "[https://assets.mixkit.co/videos/preview/mixkit-programming-interface-with-a-desktop-41568-large.mp4](https://assets.mixkit.co/videos/preview/mixkit-programming-interface-with-a-desktop-41568-large.mp4)",
    liveUrl: "https://major.niknamnuts.ir",
    color: "rgba(246, 182, 114, 1)",
    stats: {},
    doneTime: "",
    keyFeatures: [
      "Store, product, category, and product detail pages",
      "Product search and filtering",
      "Shopping cart and order flow",
      "User account management",
      "Backend API integration",
      "Reusable component architecture",
      "Responsive design",
      "State management",
      "Form validation",
      "Performance optimization",
      "SEO improvements",
    ],
    tools: ["react", "redux", "rtk", "mui"],
    myPositionInProject: "create",
    myRole: "frontend",
    teamSize: 1,
    collaborationType: "alone",
    contributionType: "full",
    teamMembers: [],
  },

  {
    _id: "7",
    title: "Hoorisa Hijab",
    description:
      "A responsive e-commerce platform for Hoorisa Hijab, including product and category pages, search, filtering, shopping cart, user accounts, and order flow.",
    longDesc:
      "An e-commerce frontend developed with React for Hoorisa Hijab. My responsibilities included implementing store, product, category, search, filtering, shopping cart, account, and ordering interfaces, as well as reusable components, API integration, state management, responsive design, and UX, performance, and SEO improvements.",
    tech: ["React.js", "Redux Toolkit", "RTK Query", "Material UI"],
    image: "/media/LiveProjects/hoorisa1.webp",
    images: [
      "/media/LiveProjects/hoorisa1.webp",
      "/media/LiveProjects/hoorisa2.webp",
    ],
    video:
      "[https://assets.mixkit.co/videos/preview/mixkit-programming-interface-with-a-desktop-41568-large.mp4](https://assets.mixkit.co/videos/preview/mixkit-programming-interface-with-a-desktop-41568-large.mp4)",
    liveUrl: "https://hijab.vira-tec.ir",
    color: "rgba(2, 144, 0, 1)",
    stats: {},
    doneTime: "",
    keyFeatures: [
      "Store, product, and category pages",
      "Product search and filtering",
      "Shopping cart",
      "User account management",
      "Order flow",
      "Reusable components",
      "Backend API integration",
      "State management",
      "Responsive design",
      "UX and performance optimization",
      "SEO optimization",
    ],
    tools: ["react", "redux", "rtk", "mui"],
    myPositionInProject: "create",
    myRole: "frontend",
    teamSize: 1,
    collaborationType: "alone",
    contributionType: "full",
    teamMembers: [],
  },

  {
    _id: "12",
    title: "Ruby Iran",
    description:
      "Frontend maintenance and development for the Ruby Iran e-commerce website, focused on bug fixing, responsive improvements, API issues, and new feature development.",
    longDesc:
      "My work on Ruby Iran focused on maintaining, updating, and improving the existing frontend. Responsibilities included identifying and fixing frontend bugs, improving responsive behavior, updating existing components, resolving form and user interaction issues, fixing API-related data display problems, refactoring parts of the codebase, improving user experience, and developing requested changes without breaking existing functionality.",
    tech: ["React.js", "Redux Toolkit", "RTK Query", "Material UI"],
    image: "/media/LiveProjects/ruby1.webp",
    images: [
      "/media/LiveProjects/ruby1.webp",
      "/media/LiveProjects/ruby2.webp",
    ],
    video:
      "[https://assets.mixkit.co/videos/preview/mixkit-programming-interface-with-a-desktop-41568-large.mp4](https://assets.mixkit.co/videos/preview/mixkit-programming-interface-with-a-desktop-41568-large.mp4)",
    liveUrl: "https://rubyiran.ir",
    color: "rgba(255, 229, 151, 1)",
    stats: {},
    doneTime: "",
    keyFeatures: [
      "Frontend bug fixing",
      "Responsive UI improvements",
      "Component improvements and updates",
      "Form and user interaction fixes",
      "API and data display fixes",
      "Frontend performance improvements",
      "Development of requested features",
      "Code refactoring",
      "Testing changes to prevent regressions",
      "User experience improvements",
    ],
    tools: ["react", "redux", "rtk", "mui"],
    myPositionInProject: "update",
    myRole: "frontend",
    teamSize: 4,
    collaborationType: "withTeam",
    contributionType: "update",
    teamMembers: ["backend developer", "jewelry consultant"],
  },

  {
    _id: "14",
    title: "RacketBook",
    description:
      "An online sports venue booking platform for discovering sports complexes, viewing available time slots, and making online reservations.",
    longDesc:
      "RacketBook is an online platform for searching and booking sports venue time slots. I developed the frontend with React, including sports complex discovery, venue pages, available time slots, booking status management, date and time selection, online reservation flow, user accounts, reservation history, search and filtering, API integration, state management, responsive UI, form validation, and loading, error, and success states.",
    tech: ["React.js"],
    image: "/media/LiveProjects/racket1.webp",
    images: [
      "/media/LiveProjects/racket1.webp",
      "/media/LiveProjects/racket1.webp",
    ],
    liveUrl: "https://racketbook.ir",
    color: "#14a23fff",
    stats: {},
    doneTime: "",
    keyFeatures: [
      "Sports complex search and discovery",
      "Sports venue and facility pages",
      "Available time-slot display",
      "Available, reserved, and unavailable slot states",
      "Date and time selection",
      "Online booking flow",
      "User account management",
      "Reservation history",
      "Search and filtering",
      "API integration",
      "Form validation",
      "Loading, error, and success UI states",
      "Responsive design",
      "Reusable components",
    ],
    tools: ["react"],
    myPositionInProject: "create",
    myRole: "frontend",
    teamSize: 1,
    collaborationType: "withTeam",
    contributionType: "full",
    teamMembers: [],
  },
  {
    _id: "17",
    title: "Vivan",
    description:
      "Frontend maintenance and development for accounting, reservation, and online menu projects, including bug fixing, feature updates, responsive improvements, and API data handling.",
    longDesc:
      "A group of existing projects including accounting, reservation, and online menu systems. My responsibilities focused on continuous frontend maintenance, bug fixing, feature development, responsive improvements, form and interaction fixes, API data handling, refactoring, performance optimization, UX improvements, testing, and implementing requested changes throughout the development lifecycle.",
    tech: ["React.js"],
    image: "/media/LiveProjects/notAllowed.jpg",
    images: [
      "/media/LiveProjects/notAllowed.jpg",
      "/media/LiveProjects/notAllowed.jpg",
    ],
    liveUrl: "",
    color: "#1a2944",
    stats: {},
    doneTime: "",
    keyFeatures: [
      "Frontend maintenance",
      "Bug fixing",
      "Feature development and updates",
      "Accounting system improvements",
      "Reservation system development",
      "Online menu updates",
      "Responsive UI improvements",
      "Form and interaction fixes",
      "API data handling improvements",
      "Code refactoring",
      "Performance optimization",
      "UX improvements",
      "Testing and regression prevention",
    ],
    tools: ["react"],
    myPositionInProject: "update",
    myRole: "frontend",
    teamSize: 1,
    collaborationType: "withTeam",
    contributionType: "update",
    teamMembers: [],
  },
];
